/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Set_Name_LabelInputs */



/**
* | output |
* | --- |
* | "Set Name" |
*
* @param {Tags_Manager_Set_Name_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_set_name_label = /** @type {((inputs?: Tags_Manager_Set_Name_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Set_Name_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom de l'ensemble")
	if (locale === "de") return /** @type {LocalizedString} */ ("Set-Name")
	if (locale === "it") return /** @type {LocalizedString} */ ("Imposta nome")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Название набора")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nombre del conjunto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("设置名称")
	if (locale === "ja") return /** @type {LocalizedString} */ ("セット名")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सेट नाम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nome do conjunto")
	return /** @type {LocalizedString} */ ("Set Name")
});